import type { TyreVehicleKind, VehicleTyreLayout } from '@chukua/common';
import { TyreDiagramPanel } from '../../../../reference-data/features/tyre-layouts/public/TyreDiagramPanel';
import { toDiagramAxles } from './vehicle-diagram-axles';

export interface RigTyreSelection {
  vehicle: TyreVehicleKind;
  code: string;
}

interface RigTyreDiagramProps {
  truck: VehicleTyreLayout;
  trailer: VehicleTyreLayout;
  selected: RigTyreSelection | null;
  onSelect: (selection: RigTyreSelection) => void;
}

/** A truck and the trailer it pulls as one vehicle in 3D (gitaumoses4/chukua#390), each in its own paint and plates; a tyre picked on either is that vehicle's. */
export function RigTyreDiagram({ truck, trailer, selected, onSelect }: RigTyreDiagramProps) {
  return (
    <TyreDiagramPanel
      className="lg:sticky lg:top-4"
      subjectKind="truck_class"
      bodyStyle={truck.bodyStyle}
      axles={toDiagramAxles(truck)}
      registration={truck.registration}
      color={truck.color}
      selectedCode={selected?.vehicle === 'truck' ? selected.code : null}
      onSelect={(code, part) => onSelect({ vehicle: part === 'towed' ? 'trailer' : 'truck', code })}
      towed={{
        bodyStyle: trailer.bodyStyle,
        axles: toDiagramAxles(trailer),
        registration: trailer.registration,
        color: trailer.color,
        selectedCode: selected?.vehicle === 'trailer' ? selected.code : null,
      }}
    />
  );
}
